(() => {
  const carouselObservers = new Map();
  let active = null;
  let trigger = null;
  let pendingAdd = false;
  const motion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const closePreview = (restoreFocus = true) => {
    if (!active) return;
    active.hidden = true;
    trigger?.setAttribute('aria-expanded', 'false');
    if (restoreFocus && trigger?.isConnected) trigger.focus();
    active = null; trigger = null; pendingAdd = false;
  };
  const positionPreview = () => {
    if (!active || !trigger) return;
    const media = active.closest('.infinity-look__media');
    if (!media || window.matchMedia('(max-width: 749px)').matches) {
      active.style.left = ''; active.style.top = ''; return;
    }
    const width = active.offsetWidth, height = active.offsetHeight;
    const x = Math.min(media.clientWidth - width - 8, Math.max(8, trigger.offsetLeft + 22));
    const availableBelow = media.clientHeight - trigger.offsetTop;
    const suggestedY = availableBelow >= height + 16 ? trigger.offsetTop + 14 : trigger.offsetTop - height - 14;
    active.style.left = `${Math.max(8, x)}px`;
    active.style.top = `${Math.max(8, Math.min(media.clientHeight - height - 8, suggestedY))}px`;
  };
  const openPreview = button => {
    const section = button.closest('[data-infinity-look]');
    const preview = [...section.querySelectorAll('[data-look-preview]')].find(el => el.dataset.lookPreview === button.dataset.lookTarget);
    if (!preview) return;
    closePreview(false);
    active = preview; trigger = button;
    preview.hidden = false;
    button.setAttribute('aria-expanded', 'true');
    positionPreview();
    preview.querySelector('.infinity-look-preview__close')?.focus();
  };
  const slides = root => [...root.querySelector('[data-carousel-track]').children];
  const currentIndex = root => {
    const track = root.querySelector('[data-carousel-track]');
    const cards = slides(root);
    if (!cards.length) return 0;
    let nearest = 0, delta = Infinity;
    cards.forEach((card, i) => { const centerOffset = root.matches('[data-infinity-look]') ? (track.clientWidth - card.clientWidth) / 2 : 0; const d = Math.abs(card.offsetLeft - track.offsetLeft - centerOffset - track.scrollLeft); if (d < delta) { delta = d; nearest = i; } });
    return nearest;
  };
  const goTo = (root, index) => {
    const track = root.querySelector('[data-carousel-track]');
    const cards = slides(root);
    if (!cards.length) return;
    const target = cards[Math.max(0, Math.min(index, cards.length - 1))];
    closePreview(false);
    const centerOffset = root.matches('[data-infinity-look]') ? (track.clientWidth - target.clientWidth) / 2 : 0;
    track.scrollTo({ left: target.offsetLeft - track.offsetLeft - centerOffset, behavior: motion() });
  };
  const refresh = root => {
    const track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    const cards = slides(root);
    const overflow = track.scrollWidth > track.clientWidth + 4;
    const arrowsAllowed = root.dataset.carouselArrows === 'true' && (root.matches('[data-infinity-look]') || window.matchMedia('(min-width: 750px)').matches);
    root.querySelectorAll('[data-carousel-prev],[data-carousel-next]').forEach(button => {
      button.hidden = !arrowsAllowed || !overflow || cards.length <= 1;
    });
    const dots = root.querySelector('[data-carousel-dots]');
    if (dots) {
      dots.hidden = root.dataset.carouselPagination !== 'true' || cards.length <= 1;
      if (dots.childElementCount !== cards.length) {
        dots.replaceChildren();
        cards.forEach((_, i) => {
          const dot = document.createElement('button'); dot.type = 'button';
          dot.className = 'infinity-carousel-dot'; dot.dataset.carouselDot = String(i);
          dot.setAttribute('aria-label', `Go to room scene ${i + 1}`);
          dots.append(dot);
        });
      }
      [...dots.children].forEach((dot, i) => dot.setAttribute('aria-current', String(i === currentIndex(root))));
    }
    const prev = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');
    if (prev && !prev.hidden) prev.disabled = track.scrollLeft < 3;
    if (next && !next.hidden) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
  };
  const initCarousel = root => {
    if (root.dataset.carouselInitialized === 'true') { refresh(root); return; }
    root.dataset.carouselInitialized = 'true';
    const track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    let frame = 0;
    track.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(() => refresh(root)); }, { passive: true });
    const observer = new ResizeObserver(() => { refresh(root); positionPreview(); });
    observer.observe(track);
    carouselObservers.set(root, observer);
    refresh(root);
  };
  const init = scope => scope.querySelectorAll('[data-infinity-category],[data-infinity-look]').forEach(initCarousel);
  document.addEventListener('click', event => {
    const hotspot = event.target.closest('[data-look-hotspot]');
    if (hotspot) { openPreview(hotspot); return; }
    if (event.target.closest('[data-look-close]')) { closePreview(); return; }
    const arrow = event.target.closest('[data-carousel-prev],[data-carousel-next]');
    if (arrow) {
      const root = arrow.closest('.infinity-carousel');
      const step = root.matches('[data-infinity-category]') ? 4 : 1;
      goTo(root, currentIndex(root) + (arrow.hasAttribute('data-carousel-next') ? step : -step));
      return;
    }
    const dot = event.target.closest('[data-carousel-dot]');
    if (dot) { goTo(dot.closest('.infinity-carousel'), Number(dot.dataset.carouselDot)); return; }
    if (active && !event.target.closest('.infinity-look-preview')) closePreview();
    const faq = event.target.closest('[data-infinity-faq]');
    if (faq) { const content = document.getElementById(faq.getAttribute('aria-controls')); if (content) { content.hidden = !content.hidden; faq.setAttribute('aria-expanded', String(!content.hidden)); } }
    const tab = event.target.closest('[data-featured-tab]');
    if (tab) {
      const list = tab.closest('.infinity-featured');
      list.querySelectorAll('[data-featured-tab]').forEach(x => x.setAttribute('aria-selected', String(x === tab)));
      list.querySelectorAll('[role=tabpanel]').forEach(x => { x.hidden = x.id !== tab.getAttribute('aria-controls'); });
    }
  });
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-look-variant]');
    if (!select) return;
    const option = select.selectedOptions[0];
    const preview = select.closest('.infinity-look-preview');
    const quantity = preview.querySelector('[name=quantity]');
    quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1'; quantity.value = quantity.min;
    const price = preview.querySelector('[data-variant-price]');
    price.replaceChildren(document.createTextNode(option.dataset.price || ''));
    if (option.dataset.compare) { const compare = document.createElement('s'); compare.textContent = option.dataset.compare; price.append(' ', compare); }
  });
  document.addEventListener('submit', event => { if (active?.contains(event.target) && event.target.matches('form[action*="/cart/add"]')) pendingAdd = true; });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, data => { if (pendingAdd && data.source === 'product-form') closePreview(false); });
    subscribe(PUB_SUB_EVENTS.cartError, data => { if (pendingAdd && data.source === 'product-form') pendingAdd = false; });
  }
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && active) { closePreview(); return; }
    if (event.key === 'Tab' && active) {
      const focusable = [...active.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled])')].filter(x => x.offsetParent !== null);
      if (focusable.length) {
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    }
    const tab = event.target.closest('[data-featured-tab]');
    if (tab && (event.key === 'ArrowRight' || event.key === 'ArrowLeft')) {
      const tabs = [...tab.closest('[role=tablist]').querySelectorAll('[data-featured-tab]')];
      const next = tabs[(tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
      next.focus(); next.click(); event.preventDefault();
    }
    const track = event.target.closest('[data-carousel-track]');
    if (track && (event.key === 'ArrowRight' || event.key === 'ArrowLeft')) {
      const root = track.closest('.infinity-carousel');
      goTo(root, currentIndex(root) + (event.key === 'ArrowRight' ? 1 : -1)); event.preventDefault();
    }
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-infinity-category],[data-infinity-look]').forEach(root => { carouselObservers.get(root)?.disconnect(); carouselObservers.delete(root); });
    if (active && event.target.contains(active)) closePreview(false);
  });
  window.addEventListener('resize', () => { document.querySelectorAll('[data-infinity-category],[data-infinity-look]').forEach(refresh); positionPreview(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true }); else init(document);
})();
